import {TFunction} from 'i18next';
import {forEach, isEmpty, set, some} from 'lodash';

import {ValidationCode} from 'enums';
import {apiUtils, dataUtils} from 'utils';

import {FIELDS} from './constants';
import {LiveHelpMessagesFields, MessageItem, MessageType} from './types';

const validateItem = (item: MessageItem, values: LiveHelpMessagesFields): boolean => {
    if (item?.type === MessageType.Text) {
        return !!item?.text;
    } else if (item?.type === MessageType.InteractiveChat) {
        return !!item?.data?.chatId && !some(values.messages, {type: MessageType.InteractiveChat});
    }
};

const validateMessages = ((messages: MessageItem[], t: TFunction) => {
    const error = {};
    const interactiveChatIndexes = [];
    forEach(messages, (m, index) => {
        if (m.type === MessageType.Text && !m.text) {
            set(error, `[${index}].${FIELDS.TEXT}`, apiUtils.getErrorMessageByCode(t, {code: ValidationCode.Required}));
        } else if (m.type === MessageType.InteractiveChat) {
            interactiveChatIndexes.push(index);
        }
    });

    if (interactiveChatIndexes.length > 1) {
        forEach(interactiveChatIndexes, (index) => {
            set(error, `[${index}].${FIELDS.TYPE}`, apiUtils.getErrorMessageByCode(t, {code: ValidationCode.Duplicated}));
        });
    }

    if (interactiveChatIndexes.length === 1 && interactiveChatIndexes[0] < messages.length - 1) {
        for (let i = interactiveChatIndexes[0] + 1; i < messages.length; i++) {
            set(error, `[${i}].${FIELDS.TYPE}`, apiUtils.getErrorMessageByCode(t, {code: ValidationCode.Invalid}));
            set(error, `[${i}].${FIELDS.TEXT}`, apiUtils.getErrorMessageByCode(t, {code: ValidationCode.Invalid}));
        }
        set(error, 'interactiveChatPosition', true);
    }

    return isEmpty(error) ? null : {messages: error};
});

const hasNoChanges = (values: LiveHelpMessagesFields, initialValues: LiveHelpMessagesFields): boolean => {
    const bothEmpty = isEmpty(initialValues) && isEmpty(values);
    const noChanges = dataUtils.isEqualValues(initialValues, values, true);
    return bothEmpty || noChanges;
};

export const liveHelpUtils = {
    validateItem,
    validateMessages,
    hasNoChanges
};